// @ts-strict-ignore
import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router'
import { IonPage } from '@ionic/react'
import { getComponentParams } from '../../home/functions'
import WithContainerRoute from 'mobile_web/modules/common/hocs/container-route'
import ScreenPanoramaComponent from '../components/ScreenPanorama'

interface ScreenPanoramaRouteParams {
	id: string
	locale: string
	tabIndex: string
}

const ScreenPanoramaRoute: FC<RouteComponentProps<ScreenPanoramaRouteParams>> = ({
	location: { state },
	match: { params },
}) => {
	const { id: itemId, version: itemVersion, accountId } = getComponentParams('collection', params, state)

	return (
		<IonPage>
			<ScreenPanoramaComponent itemId={itemId} itemVersion={itemVersion} accountId={accountId} />
		</IonPage>
	)
}

export default WithContainerRoute(ScreenPanoramaRoute)
